import { MonthlyPrayerTimes } from '../types';

export const decemberPrayerTimes: MonthlyPrayerTimes = {
  1: {
    fajr: "05:42",
    shoruk: "08:10",
    dhuhr: "11:42",
    asr: "12:48",
    maghrib: "15:03",
    isha: "17:16"
  },
  2: {
    fajr: "05:43",
    shoruk: "08:12",
    dhuhr: "11:42",
    asr: "12:48",
    maghrib: "15:02",
    isha: "17:15"
  },
  3: {
    fajr: "05:45",
    shoruk: "08:14",
    dhuhr: "11:43",
    asr: "12:47",
    maghrib: "15:01",
    isha: "17:14"
  },
  4: {
    fajr: "05:46",
    shoruk: "08:16",
    dhuhr: "11:43",
    asr: "12:46",
    maghrib: "15:00",
    isha: "17:14"
  },
  5: {
    fajr: "05:47",
    shoruk: "08:18",
    dhuhr: "11:43",
    asr: "12:46",
    maghrib: "14:59",
    isha: "17:13"
  },
  6: {
    fajr: "05:49",
    shoruk: "08:19",
    dhuhr: "11:44",
    asr: "12:46",
    maghrib: "14:58",
    isha: "17:13"
  },
  7: {
    fajr: "05:50",
    shoruk: "08:21",
    dhuhr: "11:44",
    asr: "12:45",
    maghrib: "14:58",
    isha: "17:12"
  },
  8: {
    fajr: "05:51",
    shoruk: "08:22",
    dhuhr: "11:45",
    asr: "12:45",
    maghrib: "14:57",
    isha: "17:12"
  },
  9: {
    fajr: "05:52",
    shoruk: "08:24",
    dhuhr: "11:45",
    asr: "12:45",
    maghrib: "14:56",
    isha: "17:12"
  },
  10: {
    fajr: "05:53",
    shoruk: "08:25",
    dhuhr: "11:46",
    asr: "12:44",
    maghrib: "14:56",
    isha: "17:12"
  },
  11: {
    fajr: "05:54",
    shoruk: "08:27",
    dhuhr: "11:46",
    asr: "12:44",
    maghrib: "14:55",
    isha: "17:11"
  },
  12: {
    fajr: "05:55",
    shoruk: "08:28",
    dhuhr: "11:46",
    asr: "12:44",
    maghrib: "14:55",
    isha: "17:11"
  },
  13: {
    fajr: "05:56",
    shoruk: "08:29",
    dhuhr: "11:47",
    asr: "12:44",
    maghrib: "14:54",
    isha: "17:11"
  },
  14: {
    fajr: "05:57",
    shoruk: "08:31",
    dhuhr: "11:47",
    asr: "12:44",
    maghrib: "14:54",
    isha: "17:11"
  },
  15: {
    fajr: "05:58",
    shoruk: "08:32",
    dhuhr: "11:48",
    asr: "12:44",
    maghrib: "14:54",
    isha: "17:11"
  },
  16: {
    fajr: "05:59",
    shoruk: "08:33",
    dhuhr: "11:48",
    asr: "12:44",
    maghrib: "14:54",
    isha: "17:12"
  },
  17: {
    fajr: "05:59",
    shoruk: "08:34",
    dhuhr: "11:49",
    asr: "12:45",
    maghrib: "14:54",
    isha: "17:12"
  },
  18: {
    fajr: "06:00",
    shoruk: "08:34",
    dhuhr: "11:49",
    asr: "12:45",
    maghrib: "14:54",
    isha: "17:12"
  },
  19: {
    fajr: "06:01",
    shoruk: "08:35",
    dhuhr: "11:50",
    asr: "12:45",
    maghrib: "14:54",
    isha: "17:12"
  },
  20: {
    fajr: "06:01",
    shoruk: "08:36",
    dhuhr: "11:50",
    asr: "12:46",
    maghrib: "14:55",
    isha: "17:13"
  },
  21: {
    fajr: "06:02",
    shoruk: "08:36",
    dhuhr: "11:51",
    asr: "12:46",
    maghrib: "14:55",
    isha: "17:13"
  },
  22: {
    fajr: "06:03",
    shoruk: "08:37",
    dhuhr: "11:51",
    asr: "12:46",
    maghrib: "14:56",
    isha: "17:14"
  },
  23: {
    fajr: "06:03",
    shoruk: "08:37",
    dhuhr: "11:52",
    asr: "12:47",
    maghrib: "14:56",
    isha: "17:14"
  },
  24: {
    fajr: "06:03",
    shoruk: "08:38",
    dhuhr: "11:52",
    asr: "12:48",
    maghrib: "14:57",
    isha: "17:15"
  },
  25: {
    fajr: "06:04",
    shoruk: "08:38",
    dhuhr: "11:53",
    asr: "12:48",
    maghrib: "14:58",
    isha: "17:15"
  },
  26: {
    fajr: "06:04",
    shoruk: "08:38",
    dhuhr: "11:53",
    asr: "12:49",
    maghrib: "14:58",
    isha: "17:16"
  },
  27: {
    fajr: "06:04",
    shoruk: "08:38",
    dhuhr: "11:54",
    asr: "12:50",
    maghrib: "14:59",
    isha: "17:17"
  },
  28: {
    fajr: "06:04",
    shoruk: "08:38",
    dhuhr: "11:54",
    asr: "12:51",
    maghrib: "15:00",
    isha: "17:18"
  },
  29: {
    fajr: "06:05",
    shoruk: "08:38",
    dhuhr: "11:55",
    asr: "12:51",
    maghrib: "15:01",
    isha: "17:19"
  },
  30: {
    fajr: "06:05",
    shoruk: "08:38",
    dhuhr: "11:55",
    asr: "12:52",
    maghrib: "15:03",
    isha: "17:20"
  },
  31: {
    fajr: "06:05",
    shoruk: "08:38",
    dhuhr: "11:56",
    asr: "12:53",
    maghrib: "15:04",
    isha: "17:20"
  }
};